@import 'tw-animate-css';

@custom-variant dark (&:is(.dark *));

@theme inline {
  --color-background: var(--background);
  --color-foreground: var(--foreground);
  --color-card: var(--card);
  --color-card-foreground: var(--card-foreground);
  --color-popover: var(--popover);
  --color-popover-foreground: var(--popover-foreground);
  --color-primary: var(--primary);
  --color-primary-foreground: var(--primary-foreground);
  --color-secondary: var(--secondary);
  --color-secondary-hover: var(--secondary-hover);
  --color-secondary-bright: var(--secondary-bright);
  --color-secondary-foreground: var(--secondary-foreground);
  --color-muted: var(--muted);
  --color-muted-foreground: var(--muted-foreground);
  --color-accent: var(--accent);
  --color-accent-foreground: var(--accent-foreground);
  --color-destructive: var(--destructive);
  --color-destructive-foreground: var(--destructive-foreground);
  --color-success: var(--success);
  --color-success-foreground: var(--success-foreground);
  --color-warning: var(--warning);
  --color-warning-foreground: var(--warning-foreground);
  --color-info: var(--info);
  --color-info-foreground: var(--info-foreground);
  --color-border: var(--border);
  --color-input: var(--input);
  --color-ring: var(--ring);
  --color-chart-1: var(--chart-1);
  --color-chart-2: var(--chart-2);
  --color-chart-3: var(--chart-3);
  --color-chart-4: var(--chart-4);
  --color-chart-5: var(--chart-5);
  --radius-sm: calc(var(--radius) - 4px);
  --radius-md: calc(var(--radius) - 2px);
  --radius-lg: var(--radius);
  --radius-xl: calc(var(--radius) + 4px);
  --color-sidebar: var(--sidebar);
  --color-sidebar-foreground: var(--sidebar-foreground);
  --color-sidebar-primary: var(--sidebar-primary);
  --color-sidebar-primary-foreground: var(--sidebar-primary-foreground);
  --color-sidebar-accent: var(--sidebar-accent);
  --color-sidebar-accent-foreground: var(--sidebar-accent-foreground);
  --color-sidebar-border: var(--sidebar-border);
  --color-sidebar-ring: var(--sidebar-ring);
  --font-inter: 'Inter', sans-serif;
  --color-mid-grey: var(--mid-grey);
  --color-super-dark-green: var(--super-dark-green);
  --color-semi-dark-grey: var(--semi-dark-grey);
  --color-bright-green: var(--bright-green);
  --color-ultra-dark-green: var(--ultra-dark-green);
  --color-dark-green: var(--dark-green);
  --color-plain-green: var(--plain-green);
  --color-plain-green-a11y: var(--plain-green-a11y);
  --color-pale-green: var(--pale-green);
  --color-white: var(--white);
  --color-signal-red: var(--signal-red);
  --color-signal-orange: var(--signal-orange);
  --color-signal-green: var(--signal-green);
  --color-dark-grey: var(--dark-grey);
  --color-light-grey: var(--light-grey);
  --color-off-white: var(--off-white);
  --shadow-800:
    0px 8px 28px -6px rgba(24, 39, 75, 0.12),
    0px 18px 88px -4px rgba(24, 39, 75, 0.14);
  --drop-shadow-glow:
    0 0px 16px rgba(2, 151, 97, 0.6), 0 0px 40px rgba(2, 151, 97, 0.1);
}

:root {
  --background: oklch(1 0 0);
  --foreground: oklch(0.145 0 0);
  --card: oklch(1 0 0);
  --card-foreground: oklch(0.145 0 0);
  --popover: oklch(1 0 0);
  --popover-foreground: oklch(0.145 0 0);
  --primary: oklch(0.3458 0.0404 213.11);
  --primary-foreground: oklch(1 0 0);
  --secondary: oklch(0.5436 0.1252 158.9);
  --secondary-hover: oklch(0.58 0.1252 158.9);
  --secondary-bright: oklch(0.7371 0.1689 159.07);
  --secondary-foreground: oklch(1 0 0);
  --muted: oklch(0.97 0 0);
  --muted-foreground: oklch(0.556 0 0);
  --accent: oklch(0.97 0 0);
  --accent-foreground: oklch(0.205 0 0);
  --destructive: oklch(0.577 0.245 27.325);
  --destructive-foreground: oklch(0.577 0.245 27.325);
  --success: oklch(0.65 0.18 145);
  --success-foreground: oklch(0.145 0 0);
  --info: oklch(0.55 0.13 250);
  --info-foreground: oklch(0.145 0 0);
  --warning: oklch(0.65 0.18 60);
  --warning-foreground: oklch(0.145 0 0);
  --border: oklch(0.9373 0.0013 286.37);
  --input: oklch(0.922 0 0);
  --ring: oklch(0.7371 0.1689 159.07);
  --chart-1: oklch(0.646 0.222 41.116);
  --chart-2: oklch(0.6 0.118 184.704);
  --chart-3: oklch(0.398 0.07 227.392);
  --chart-4: oklch(0.828 0.189 84.429);
  --chart-5: oklch(0.769 0.188 70.08);
  --radius: 0.625rem;
  --sidebar: oklch(0.985 0 0);
  --sidebar-foreground: oklch(0.145 0 0);
  --sidebar-primary: oklch(0.205 0 0);
  --sidebar-primary-foreground: oklch(0.985 0 0);
  --sidebar-accent: oklch(0.97 0 0);
  --sidebar-accent-foreground: oklch(0.205 0 0);
  --sidebar-border: oklch(0.922 0 0);
  --sidebar-ring: oklch(0.708 0 0);
  --super-dark-green: oklch(0.3071 0.0409 195.24);
  --mid-grey: oklch(0.7241 0.0037 247.87);
  --semi-dark-grey: oklch(0.4423 0 0);
  --bright-green: oklch(0.7979 0.1692 159.07);
  --ultra-dark-green: oklch(0.1876 0.0089 188.64);
  --dark-green: oklch(0.3735 0.0934 166.69);
  --plain-green: oklch(0.5436 0.1252 158.9);
  --plain-green-a11y: oklch(0.4938 0.1102 159.28);
  --pale-green: oklch(0.9648 0.0811 163.68);
  --white: oklch(1 0 0);
  --signal-red: oklch(0.5514 0.2472 29.23);
  --signal-orange: oklch(0.7451 0.1609 64.42);
  --signal-green: oklch(0.7524 0.1842 142.5);
  --dark-grey: oklch(0.1454 0.0019 264.05);
  --light-grey: oklch(0.9297 0.0012 264.05);
  --off-white: oklch(0.9754 0.0006 264.05);
}

.dark {
  --background: oklch(0.145 0 0);
  --foreground: oklch(0.985 0 0);
  --card: oklch(0.145 0 0);
  --card-foreground: oklch(0.985 0 0);
  --popover: oklch(0.145 0 0);
  --popover-foreground: oklch(0.985 0 0);
  --primary: oklch(0.985 0 0);
  --primary-foreground: oklch(0.205 0 0);
  --secondary: oklch(0.269 0 0);
  --secondary-hover: oklch(0.269 0.1 0);
  --secondary-bright: oklch(0.7371 0.1689 159.07);
  --secondary-foreground: oklch(0.985 0 0);
  --muted: oklch(0.269 0 0);
  --muted-foreground: oklch(0.708 0 0);
  --accent: oklch(0.269 0 0);
  --accent-foreground: oklch(0.985 0 0);
  --destructive: oklch(0.396 0.141 25.723);
  --destructive-foreground: oklch(0.637 0.237 25.331);
  --success: oklch(0.45 0.18 145);
  --success-foreground: oklch(0.985 0 0);
  --info: oklch(0.35 0.13 250);
  --info-foreground: oklch(0.985 0 0);
  --warning: oklch(0.45 0.18 60);
  --warning-foreground: oklch(0.985 0 0);
  --border: oklch(0.269 0 0);
  --input: oklch(0.269 0 0);
  --ring: oklch(0.439 0 0);
  --chart-1: oklch(0.488 0.243 264.376);
  --chart-2: oklch(0.696 0.17 162.48);
  --chart-3: oklch(0.769 0.188 70.08);
  --chart-4: oklch(0.627 0.265 303.9);
  --chart-5: oklch(0.645 0.246 16.439);
  --sidebar: oklch(0.205 0 0);
  --sidebar-foreground: oklch(0.985 0 0);
  --sidebar-primary: oklch(0.488 0.243 264.376);
  --sidebar-primary-foreground: oklch(0.985 0 0);
  --sidebar-accent: oklch(0.269 0 0);
  --sidebar-accent-foreground: oklch(0.985 0 0);
  --sidebar-border: oklch(0.269 0 0);
  --sidebar-ring: oklch(0.439 0 0);
  --super-dark-green: oklch(0.3071 0.0409 195.24);
  --mid-grey: oklch(0.7241 0.0037 247.87);
  --semi-dark-grey: oklch(0.384 0.0017 247.87);
  --bright-green: oklch(0.7979 0.1692 159.07);
  --ultra-dark-green: oklch(0.1876 0.0089 188.64);
  --dark-green: oklch(0.3735 0.0934 166.69);
  --plain-green: oklch(0.5436 0.1252 158.9);
  --plain-green-a11y: oklch(0.4938 0.1102 159.28);
  --pale-green: oklch(0.9648 0.0811 163.68);
  --white: oklch(1 0 0);
  --signal-red: oklch(0.5514 0.2472 29.23);
  --signal-orange: oklch(0.7451 0.1609 64.42);
  --signal-green: oklch(0.7524 0.1842 142.5);
  --dark-grey: oklch(0.1454 0.0019 264.05);
  --light-grey: oklch(0.9297 0.0012 264.05);
  --off-white: oklch(0.9754 0.0006 264.05);
}

@layer base {
  * {
    @apply border-border outline-ring/50;
  }
  body {
    @apply bg-background text-foreground;
  }
}
